<template>
  <div>
    <section class="pt-4 mb-4">
      <div class="container text-center">
        <div class="row">
          <div class="col-lg-6 text-center text-lg-left">
            <h1 class="fw-600 h4">{{ $t(title) }}</h1>
          </div>
          <div class="col-lg-6">
            <ul
              class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
            >
              <li class="breadcrumb-item opacity-50">
                <router-link class="text-reset" to="/"
                  >{{ $t("首页") }}
                </router-link>
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset" href="javascript:void(0);">{{
                  $t(title)
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-4">
      <div class="container">
        <div
          class="p-4 bg-white rounded shadow-sm overflow-hidden mw-100 text-left"
          v-html="html"
        ></div>
      </div>
    </section>
  </div>
</template>
<script>
import { getDetail } from "@/api/poster";

export default {
  data() {
    return { title: "", html: "" };
  },
  methods: {
    async getHtml() {
      const res = await getDetail(this.$route.query.code);
      this.title = res.data.title;
      this.html = res.data.content;
    }
  },
  watch: {
    $route: {
      handler() {
        this.getHtml();
      }
    }
  },
  created() {
    this.getHtml();
  }
};
</script>
